import { InverterApi } from 'api/InverterApi';
import { useAppSelector } from 'app/hooks';
import clsx from 'clsx';
import {
  selectInverterItemSidebar,
  selectPlantItemSidebar,
  selectSidebarList,
} from 'components/Common/Sidebar/sidebarSlice';
import OutputEnergy from 'features/Inverter/components/OutputEnergy/OutputEnergy';
import ProductionInfo from 'features/Inverter/components/ProductionInfo/ProductionInfo';
import { inverterInfo, plantInfo, ResponseData } from 'models';
import moment from 'moment';
import * as React from 'react';
import { customizeDataInverters } from 'utils/common';
import { sumArray } from '../../../../utils/common';
import DeviceGraph from '../../components/DeviceGraph/DeviceGraph';
import style from './InverterHomePage.module.scss';
export interface InverterHomePageProps {}

export default function InverterHomePage(props: InverterHomePageProps) {
  const plantList = useAppSelector(selectSidebarList);
  const inverterId = useAppSelector(selectInverterItemSidebar);
  const plantId = useAppSelector(selectPlantItemSidebar);
  const [objectInverter, setObjectInverter] = React.useState<inverterInfo>();
  const [hourly, setHourly] = React.useState<ResponseData[]>();
  const [daily, setDaily] = React.useState<ResponseData[]>();
  const [monthly, setMonthly] = React.useState<ResponseData[]>();
  const [lifeTime, setLifeTime] = React.useState<ResponseData[]>();
  const [innerTemp, setInnerTemp] = React.useState<ResponseData[]>();
  const [inverterConfig, setInverterConfig] = React.useState<any>(null);

  React.useEffect(() => {
    if (inverterId && plantList) {
      (async () => {
        const newObject: inverterInfo | undefined = await customizeDataInverters(plantList).find(
          (item) => item.id === inverterId
        );
        const response: inverterInfo = await InverterApi.fetchInverterInfo({
          type: 'inverter_id',
          id: inverterId,
        });
        const label_plant: plantInfo | undefined = await plantList.find(
          (item) => item.id === plantId
        );
        setObjectInverter({ ...newObject, ...response, label_plant: label_plant?.label });
        const responseHourly: ResponseData[] = await InverterApi.fetchStatisticByTime({
          type: 'output-energy',
          id: inverterId,
          typeTime: 'hourly',
          dateTime: moment().format('YYYY-MM-DD'),
        });
        const responseDaily: ResponseData[] = await InverterApi.fetchStatisticByTime({
          type: 'output-energy',
          id: inverterId,
          typeTime: 'daily',
          dateTime: moment().format('YYYY-MM'),
        });
        const responseMonthly: ResponseData[] = await InverterApi.fetchStatisticByTime({
          type: 'output-energy',
          id: inverterId,
          typeTime: 'monthly',
          dateTime: moment().format('YYYY'),
        });
        const responseText: any = await InverterApi.fetchStatisticByDevice({
          text: 'total_cum_out_e,inner_temp',
          id: inverterId,
        });
        setHourly(responseHourly);
        setDaily(responseDaily);
        setMonthly(responseMonthly);
        setLifeTime(responseText.total_cum_out_e);
        setInnerTemp(responseText.inner_temp);
      })();
    }
  }, [inverterId, plantList]);

  React.useEffect(() => {
    if (objectInverter) {
      (async () => {
        const response: any = await InverterApi.fetchInverterConfig({
          type: objectInverter.type,
          name: 'home_of_inverter',
        });
        setInverterConfig(response);
      })();
    }
  }, [objectInverter]);

  return (
    <div className={style.root}>
      <div className={style.inverter_info}>
        <div className={style.inverter_name}>
          <div
            className={clsx(style.icon_active, {
              [style.active]: objectInverter?.active,
            })}
          ></div>
          {objectInverter?.label}
        </div>
        <div className={style.information}>
          <div className={style.detail_info}>{`Trạm: ${objectInverter?.label_plant}`}</div>
          <div className={style.detail_info}>{`Mã thiết bị: ${objectInverter?.code}`}</div>
        </div>
      </div>
      <div className={style.header_inverter}>
        <div className={style.details_inverter}>
          <div className={style.item_details_inverter}>
            <div className={style.label_details_inverter}>S/N:</div>
            <div className={style.value_details_inverter}>{objectInverter?.serial_number}</div>
          </div>
          <div className={style.item_details_inverter}>
            <div className={style.label_details_inverter}>Connect Time:</div>
            <div className={style.value_details_inverter}>
              {moment(objectInverter?.last_connect_time).format('YYYY-MM-DD HH:mm:ss')}
            </div>
          </div>
          <div className={style.item_details_inverter}>
            <div className={style.label_details_inverter}>Model:</div>
            <div className={style.value_details_inverter}>{objectInverter?.type}</div>
          </div>
          <div className={style.item_details_inverter}>
            <div className={style.label_details_inverter}>Last Reported:</div>
            <div className={style.value_details_inverter}>
              {moment(objectInverter?.last_activity_time).format('YYYY-MM-DD HH:mm:ss')}
            </div>
          </div>
        </div>
        <div className={style.statistic_inverter}>
          <div className={style.item_inverter_header}>
            <div className={style.image_item_header}>
              <div className={style.image_today}></div>
            </div>
            <div className={style.container_item_header}>
              <div className={style.content_item_header}>
                <div className={style.label_item_header}>TODAY</div>
                <div className={style.value_item_header}>
                  {hourly ? `${sumArray(hourly, true).toLocaleString()} kWh` : `N/A`}{' '}
                </div>
              </div>
            </div>
          </div>
          <div className={style.item_inverter_header}>
            <div className={style.image_item_header}>
              <div className={style.image_month}></div>
            </div>
            <div className={style.container_item_header}>
              <div className={style.content_item_header}>
                <div className={style.label_item_header}>THIS MONTH</div>
                <div className={style.value_item_header}>
                  {daily ? `${sumArray(daily, true).toLocaleString()} kWh` : `N/A`}{' '}
                </div>
              </div>
            </div>
          </div>
          <div className={style.item_inverter_header}>
            <div className={style.image_item_header}>
              <div className={style.image_year}></div>
            </div>
            <div className={style.container_item_header}>
              <div className={style.content_item_header}>
                <div className={style.label_item_header}>THIS YEAR</div>
                <div className={style.value_item_header}>
                  {monthly ? `${sumArray(monthly, true).toLocaleString()} kWh` : `N/A`}{' '}
                </div>
              </div>
            </div>
          </div>
          <div className={style.item_inverter_header}>
            <div className={style.image_item_header}>
              <div className={style.image_lifetime}></div>
            </div>
            <div className={style.container_item_header}>
              <div className={style.content_item_header}>
                <div className={style.label_item_header}>LIFE TIME</div>
                <div className={style.value_item_header}>
                  {lifeTime ? `${sumArray(lifeTime, true).toLocaleString()} kWh` : `N/A`}{' '}
                </div>
              </div>
            </div>
          </div>
          <div className={style.item_inverter_header}>
            <div className={style.image_item_header}>
              <div className={style.inner_temperature}></div>
            </div>
            <div className={style.container_item_header}>
              <div className={style.content_item_header}>
                <div className={style.label_item_header}>INNER TEMP</div>
                <div className={style.value_item_header}>
                  {innerTemp
                    ? `${sumArray(innerTemp, false).toLocaleString(undefined, {
                        style: 'unit',
                        unit: 'celsius',
                      })}`
                    : `N/A`}{' '}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {inverterConfig?.production_info_panel?.display && <ProductionInfo />}
      {inverterConfig?.param_graph_panel?.display && (
        <>
          <DeviceGraph optionSelect={inverterConfig.param_graph_panel.config.param_list} />
          <OutputEnergy />
        </>
      )}
      {/* <DeviceGraph optionSelect={inverterConfig.param_graph_panel.config.param_list} /> */}
    </div>
  );
}
